export const colors = [
  "#004aad",
  "#8c52ff",
  "#c60000",
  "#00a0bd",
  "#298821",
  "#e07200",
  "#6e3208",
  "#5c5c5c",
  "#de3193",
];
